export const environment = {
  env: 'develop',
  production: false,
  apiUrl: 'https://ucts-file-share-download.itsbackup.biz/',
  advertisementImgUrl: 'https://stfilesharewinappdevelop.blob.core.windows.net/advertisement/header_uctsfileshare.png',
  advertisementExternalUrl: 'https://www.uchida-it.co.jp/product/uc_series/ucfileshare/'
};
